import cookie from 'js-cookie';

/**
 * Attributes applied to every cookie this app writes (SECURITY.md FE-01).
 *
 * - sameSite=lax: the cookie is not attached to cross-site POST/fetch requests,
 *   which blocks CSRF-style reuse of the session token.
 * - secure: only sent over HTTPS. It is conditional on the current origin
 *   because browsers silently drop a `secure` cookie set from an http:// page,
 *   which would break login on local dev servers. Production is HTTPS.
 *
 * HttpOnly cannot be set from JavaScript; that needs the backend to issue the
 * cookie itself (cvso-express SECURITY.md BE-11).
 *
 * `remove` must be given the same path/sameSite/secure attributes as `set`,
 * otherwise the browser treats it as a different cookie and keeps the original.
 */
const cookieAttributes = () => ({
  path: '/',
  sameSite: 'lax',
  secure:
    typeof window !== 'undefined' &&
    window.location &&
    window.location.protocol === 'https:',
});

export const setCookie = (key, value) => {
  if (process.browser) {
    cookie.set(key, value, {
      expires: 1,
      ...cookieAttributes(),
    });
  }
};

export const removeCookie = key => {
  if (process.browser) {
    cookie.remove(key, cookieAttributes());
  }
};

export const getCookie = (key, req) => {
  return process.browser
    ? getCookieFromBrowser(key)
    : getCookieFromServer(key, req);
};

const getCookieFromBrowser = key => {
  return cookie.get(key);
};

const getCookieFromServer = (key, req) => {
  if (!req.headers.cookie) {
    return undefined;
  }
  const rawCookie = req.headers.cookie
    .split(';')
    .find(c => c.trim().startsWith(`${key}=`));
  if (!rawCookie) {
    return undefined;
  }
  return rawCookie.split('=')[1];
};
